import { render, staticRenderFns } from "./blankSpace.vue?vue&type=template&id=15c2b20a&scoped=true&"
var script = {}
import style0 from "./blankSpace.vue?vue&type=style&index=0&id=15c2b20a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2b20a",
  null
  
)

export default component.exports